import { defineMessage } from 'services/localization';

export const messages = {
    errorStateIdEmpty: defineMessage('state_id_is_empty'),
    errorSetupCodeEmpty: defineMessage('setup_code_is_empty'),
    errorSetupVerificationCodeEmpty: defineMessage('wrong_code'),
    errorBackupMethodEmpty: defineMessage('wrong_backup_method'),
    errorCodesAreSaved: defineMessage('this_checkbox_is_required'),
    errorEmailEmpty: defineMessage('email_address_is_required'),
    errorEmailInvalid: defineMessage('this_email_address_is_not_valid'),
    errorEmailVerificationCodeRequired: defineMessage('wrong_code'),
};
